import { OperationLogMapper } from "@/data/mapper/admin/operation-log-mapper";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { OperationLogSource } from "@/data/source/operation-log-source";
import { PagedLogs } from "@/domain/entity/admin/operation-log-entity";
import { OperationLogRepository } from "@/domain/repository/operation-log-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class OperationLogRepositoryImpl implements OperationLogRepository {
  constructor(private readonly operationLogSource: OperationLogSource) {}

  async fetchLogs(page: number, pageSize: number): Promise<SATResult<PagedLogs, SATError>> {
    const result = await this.operationLogSource.fetchLogs(page, pageSize);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      OperationLogMapper.toEntity,
      "OperationLogRepositoryImpl::fetchLogs",
    );
  }
}
